export default __webpack_public_path__ + "static/media/9.085cf99f.png";